import * as React from "react";
const SvgLogo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#7600FF", d: "M21.2885 0H0v10.7568h13.7097L1.88932 22.627l7.57343 7.6054L21.2885 18.3622V32H32V0H21.2885Z" }));
export default SvgLogo;
